import { cn } from "@/lib/utils"
import { Check } from "lucide-react"

const CheckCircle = ({className}: {className?: string}) => {
  return (
    <div className={cn("flex items-center justify-center bg-green-600 rounded-full h-[50px] w-[50px]", className)}>
      <Check className="stroke-white stroke-3 h-8 w-8" />
    </div>
  )
}

export default CheckCircle;